<script>
/**
 * @Author: zuokangsheng
 * @Date:   2021-11-16 18:46:29
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2023-11-13 10:22:34
 */
</script>
<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  mounted() {
    window.setTracker();
    window.xkwTracker.$single_page_app = true;
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/common.scss";
@import "../src/assets/icon/iconfont.css";
.el-loading-mask {
  z-index: 9999 !important;
}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
